import AdminAddOwner from './AdminAddOwner';

export default AdminAddOwner;
